<!-- https://echarts.apache.org/examples/zh/editor.html?c=mix-line-bar -->
<template>
  <div ref="chart" style="width: 100%; height: 500px;"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'ClientECharts',
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      chartInstance: null,
      localChartData: null, // 本地数据副本
      initialChartData: null // 保存初始数据的副本
    }
  },
  mounted () {
    this.localChartData = JSON.parse(JSON.stringify(this.chartData)) // 初始化本地数据副本
    this.initialChartData = JSON.parse(JSON.stringify(this.chartData)) // 保存初始数据的副本
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
    }
  },
  watch: {
    chartData: {
      handler (newVal) {
        if (this.chartInstance && newVal) {
          this.localChartData = JSON.parse(JSON.stringify(newVal))
          this.initialChartData = JSON.parse(JSON.stringify(newVal))
          this.updateChart()
        }
      },
      deep: true // 深度监听对象的变化
    }
  },
  methods: {
    initChart () {
      this.chartInstance = echarts.init(this.$refs.chart)
      this.updateChart()
      this.chartInstance.on('restore', this.handleRestore) // 监听 restore 事件
    },
    updateChart () {
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        legend: {
          data: ['总客源数', '跟进数', '面访数', '带看数']
        },
        xAxis: [
          {
            type: 'category',
            data: this.chartData.xAxisData,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value} 人'
            }
          },
          {
            type: 'value',
            min: 0,
            axisLabel: {
              formatter: '{value} 人'
            }
          }
        ],
        series: [
          {
            name: '总客源数',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' 人'
              }
            },
            data: this.localChartData.seriesData.clientCount
          },
          {
            name: '跟进数',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' 人'
              }
            },
            data: this.localChartData.seriesData.followUpCount
          },
          {
            name: '面访数',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' 人'
              }
            },
            data: this.localChartData.seriesData.interviewCount
          },
          {
            name: '带看数',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' 人'
              }
            },
            data: this.localChartData.seriesData.takeLookCount
          }
        ]
      }
      this.chartInstance.setOption(option)
    },
    handleResize () {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    },
    handleRestore () {
      // 使用初始数据副本恢复图表
      this.localChartData = JSON.parse(JSON.stringify(this.initialChartData))
      this.updateChart()
    }
  }
}
</script>

<style scoped lang="less">
/* 根据需要添加样式 */
</style>
